/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
export class Logger {
  /**
   * Log debug information
   * @param props - Any arguments to log
   */
  static debug(...props: any[]): void {
    if (process.env.REACT_APP_ENVIRONMENT !== 'production') {
      console.debug('[DEBUG]', ...props);
    }
  }

  /**
   * Log error information
   * @param context - Additional context about the error
   * @param error - The error to log
   */
  static error(context: string | undefined, error: unknown): void {
    const errorMessage = error instanceof Error ? error.message : String(JSON.stringify(error));
    const errorStack = error instanceof Error ? error.stack : undefined;
    
    console.error('[ERROR]', context ? `${context}: ${errorMessage}` : errorMessage);
    
    if (errorStack) {
      console.error('[ERROR STACK]', errorStack);
    }
  }

  /**
   * Log informational messages
   * @param props - Any arguments to log
   */
  static info(...props: any[]): void {
    console.info('[INFO]', ...props);
  }


  /**
   * Log warning messages
   * @param props - Any arguments to log
   */
  static warn(...props: any[]): void {
    console.warn('[WARN]', ...props);
  }
}

export default Logger; 